<template>
  <div id="data-list-list-view" class="data-list-container">

    <vx-card v-if="filter" ref="filterCard" :title="$t('Filter')" class="user-list-filters mb-4" actionButtons @refresh="initInput" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
          <p class="mb-2" >{{ $t("Post") }} </p>
          <v-select :options="postes" multiple
          :reduce="rep => rep.id" @search="getPoste" :clearable="true" label="libellePoste" v-model="input.postes" class="w-full"/> 
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
          <p class="mb-2" >{{ $t("level") }} </p>
          <v-select :options="niveaus" 
          :reduce="rep => rep.id" @search="getNiveau" :clearable="true" label="libelle" v-model="input.niveau" class="w-full"/>                
        </div>
      </div>
    </vx-card>

    <vs-table :noDataText="$t('No_data_Available')" ref="table" :data="postEmployes">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewEmployee">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ $t("add") }}</span>
          </div>

          <vx-tooltip :text="$t('Filterlist')" color="warning">
            <div class="btn-add-new p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning" @click="filter=!filter">
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            </div>
          </vx-tooltip>
        </div>

          
        <div class="flex flex-wrap">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ param.paginate.page * param.paginate.length - (param.paginate.length - 1) }} - {{ taille - param.paginate.page * param.paginate.length > 0 ? param.paginate.page * param.paginate.length : taille }} {{ $t("of_sur") }} {{ taille }}</span>
              <feather-icon icon="ChevronDownIcon" svgPostEmployes="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item :key="indexItem" v-for="(item, indexItem) in itemsPerPages" @click="param.paginate.length=item, getPostEmployes()">
                <span> {{item}} </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input icon-pack="feather" icon="icon-search" :placeholder="$t('Search')" v-model="search" class="is-label-placeholder mb-8" />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="employe.matriculeCnss">{{ $t("Cnss_Registration_number") }}</vs-th>
        <vs-th sort-key="employe.full_name">{{ $t("full_name") }}</vs-th>
        <vs-th sort-key="employe.dateEntree">{{ $t("Entry_date") }}</vs-th>
        <vs-th sort-key="employe.dateNaissance">{{ $t("Date_of_Birth") }}</vs-th>
        <vs-th sort-key="employe.sexe.code">{{ $t("sex") }}</vs-th>
        <vs-th sort-key="employe.salaire_brute">{{ $t("Gross_wages") }}</vs-th>
        <vs-th sort-key="employe.declarer">{{ $t("declared") }} ?</vs-th>
        <vs-th>{{ $t("action") }}</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.employe.matriculeCnss }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.employe.full_name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ $store.state.convertDateTime(new Date(tr.employe.dateEntree)).date }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ $store.state.convertDateTime(new Date(tr.employe.dateNaissance)).date }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.employe.sexe ? tr.employe.sexe.code : '' }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.employe.salaire_brute }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.employe.declarer)" class="product-order-status">{{ tr.employe.declarer ? 'OUI' : 'NON' }}</vs-chip>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="flex">
                  <vx-tooltip :text="$t('update')" color="warning">
                    <feather-icon
                      style="color: #FF9F43"
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-warning stroke-current"
                      class="mr-2"
                      @click="edit(tr.id)"
                    />
                  </vx-tooltip>
                  <vx-tooltip :text="$t('Delete')" color="danger">
                    <feather-icon
                      @click="postEmploye_delete(tr.id)"
                      style="color: red"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                </div>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <div class="items-center">
      <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
    </div>

  </div>
</template>

<script>
let base_self = ''
import moduleDataList from '@/store/data-list/moduleDataList.js'

// PostEmploye
const input_tempon = {
  postes: [],
  niveau: ''
}

export default {
  components: {
  },
  data () {
    return {
      niveaus: [],
      postes: [],
      classes: [],
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      filter: false,
      search: '',
      param: {
        is_get: true,
        paginate: {
          length: 100,
          page: 1
        },
        filter: {
          q_list: [],
          anneeScolaire__cloture: false,
          anneeScolaire__encours: true
        },
        orderby: ['employe__full_name']
      },
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      selected: [],
      postEmployes: [],
      isMounted: false,
      sidebarData: {}
    }
  },
  watch: {
    input: {
      handler  () {
        if (base_self.input1.postes.length !== base_self.input.postes.length) {
          if (!base_self.input.postes.length) {
            delete base_self.param.filter['postes__id__in']
          } else {
            base_self.param.filter['postes__id__in'] = base_self.input.postes
          }
        }

        if (base_self.input1.niveau !== base_self.input.niveau) {
          if (!base_self.input.niveau || base_self.input.niveau === '') {
            delete base_self.param.filter['niveau']
          } else {
            base_self.param.filter['niveau'] = base_self.input.niveau
          }
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
        base_self.getPostEmployes()
      },
      deep: true
    },
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getPostEmployes()
    },
    search (value) {
      if (value.length) {
        base_self.param.filter.q_list = [
          { 'employe__matriculeCnss__icontains': value },
          { 'employe__full_name__icontains': value },
          { 'employe__dateEntree__icontains': value },
          { 'employe__dateNaissance__icontains': value },
          { 'employe__sexe__code__icontains': value },
          { 'employe__salaire_brute__icontains': value }
        ]
      } else {
        base_self.param.filter.q_list = []
      }
      base_self.getPostEmployes()
    }
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    getOrderStatusColor (is_ok) {
      if (is_ok)   return 'success'
      return 'primary'
    },
    addNewEmployee () {
      base_self.$router.push(`/Employee_management/Employee/${0}`).catch(() => {})
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.$refs.filterCard.removeRefreshAnimation()
    },
    getPosteSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Poste`, data)
        .then((response) => {
          base_self.postes = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },   
    getPoste (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Poste`, data)
        .then((response) => {
          base_self.postes = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getClasseSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },   
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true, libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getNiveauSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },   
    getNiveau (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    edit (id) {
      base_self.$router.push(`/Employee_management/Employee/${id}`).catch(() => {})
    },
    async postEmploye_delete (id) {
      
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_deletion'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          // console.log('id: ', id)
          const params = {
            id
          }
          
          base_self.$http.delete(`${base_self.$store.state.route_for_esm}PostEmploye`, { params })
            .then((response) => {
              window.getESM.success(base_self.$t('The_class_is_deleted_successfully'), response)
            })
            .catch(() => {
              window.getESM.error(base_self.$t('Class_removal_failed'))
            })
        }
      })
    },
    async getPostEmployes () {
      base_self.$vs.loading()
      base_self.$http.post(`${base_self.$store.state.route_for_esm}PostEmploye`, base_self.param)
        .then((response) => {
          base_self.postEmployes = response.data.data
          base_self.taille = response.data.taille

          console.log('base_self.postEmployes: ', base_self.postEmployes)

          base_self.$vs.loading.close()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          base_self.$vs.loading.close()
        })
    },
    PostEmployeWebSocket () {
      base_self.$store.state.webSocketFunction(base_self, 'postEmploye')
    }
  },
  created () {
    base_self = this
    base_self.PostEmployeWebSocket()
    base_self.getPostEmployes()
    base_self.getNiveauSimple()
    base_self.getClasseSimple()
    base_self.getPosteSimple()

    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('dataList/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}

</style>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
